import React from "react";
import "../css/my style.css";



export default function Tryitout() {
    return(
        <button type="submit" className="tryitoutbtn">Try it out</button>
    )
}